const enum ToChart {
    Month = 0,
    Year = 1,
}

export default ToChart;